import React, { useCallback, useEffect, useRef, useState } from "react";
import "./Header.css";
import useJumboLayoutSidebar from "@jumbo/hooks/useJumboLayoutSidebar";
import AuthUserDropdown from "../../../../shared/widgets/AuthUserDropdown";
import NotificationsDropdown from "../../../../shared/NotificationsDropdown";
import MessagesDropdown from "../../../../shared/MessagesDropdown";
import {
  Box,
  IconButton,
  Link,
  Tooltip,
  Typography,
  useMediaQuery,
  Badge,
} from "@mui/material";
import { useApprovalListPaginationQuery } from "app/services/RTK_Apis/Approvals/approvalApi";
import Div from "@jumbo/shared/Div";
import MenuIcon from "@mui/icons-material/Menu";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import Logo from "../../../../shared/Logo";
import { SIDEBAR_STYLES, SIDEBAR_VARIANTS } from "@jumbo/utils/constants";
import useJumboHeaderTheme from "@jumbo/hooks/useJumboHeaderTheme";
import { DrawerHeader } from "@jumbo/components/JumboLayout/style";
import { useLocation, useNavigate } from "react-router-dom";
import { MoreVertRounded } from "@mui/icons-material";
// import { FcApproval } from "react-icons/fc";
import useApp from "app/hooks/useApp";
import { ASSET_IMAGES } from "app/utils/constants/paths";
import Tallylogo from "../../../../../assets/images/TallyLogo.png";
// import CRMlogo from '../../../../../assets/images/CRM_Farm_Logo.png'
import CRMlogo from "../../../../../assets/images/CRM_FARM_LOGO_Final.png";
// import Boltlogo from "../../../../../assets/images/BoltMM.png";
// import { Tenantname } from "app/services/auth-services";
// import FactCheckRoundedIcon from "@mui/icons-material/FactCheckRounded";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";

const Header = () => {
  let userDetails = localStorage.getItem("UserDetails");
  userDetails = JSON.parse(userDetails);
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width:768px)");

  const employeeId = parseInt(localStorage.getItem("EmployeeId") || "0");
  const { data: approvalResponse } = useApprovalListPaginationQuery(
    { userId: employeeId, page: 1, pageSize: 10 },
    { skip: !employeeId },
  );
  const approvalsCount = approvalResponse?.count || 0;

  const userType = userDetails?.UserType;

  const { sidebarOptions, setSidebarOptions } = useJumboLayoutSidebar();

  const { headerTheme } = useJumboHeaderTheme();

  const showDropdownSearch = useMediaQuery("(max-width:575px)");

  const showHeaderMenu = useMediaQuery("(min-width:575px)");

  // useEffect(() => {
  //   const handler = (event) => {
  //     if (isActive && ref.current && !ref.current.contains(event.target)) {
  //       setIsActive(false);
  //     }
  //   };
  //   document.addEventListener("mousedown", handler);
  //   document.addEventListener("touchstart", handler);
  //   return () => {
  //     // Cleanup the event listener
  //     document.removeEventListener("mousedown", handler);
  //     document.removeEventListener("touchstart", handler);
  //   };
  // }, [isActive]);

  const { customizerVisibility, setCustomizerVisibility } = useApp();

  const toggleCustomizerVisibility = useCallback(() => {
    setCustomizerVisibility(!customizerVisibility);
  }, [setCustomizerVisibility, customizerVisibility]);

  const location = useLocation();
  const [previousPage, setPreviousPage] = useState("");

  useEffect(() => {
    const currentPage = location.pathname;

    // Save previous page before updating current page
    setPreviousPage(currentPage);
  }, [location]);

  return (
    <Div
      sx={{
        width: "100vw !important",
        position: "sticky",
        top: 0,
        zIndex: "9999 !important",
        display: "flex !important",
        justifyContent: "space-between !important",
        pl: sidebarOptions.open
          ? { xl: "5%", lg: "6%", md: "5%", xs: "0%" }
          : { xll: "2%", xl: "1%", lg: "3%", md: "4%", xs: "0%" },
        pr: sidebarOptions.open
          ? { xl: "7%", lg: "7%", md: "6%", xs: "0%" }
          : { xll: "6%", xl: "6%", lg: "7%", md: "7%", xs: "0%" },
      }}
    >
      {(sidebarOptions.style === SIDEBAR_STYLES.CLIPPED_UNDER_HEADER ||
        sidebarOptions.variant === SIDEBAR_VARIANTS.TEMPORARY ||
        (sidebarOptions.variant === SIDEBAR_VARIANTS.PERSISTENT &&
          !sidebarOptions.open)) && (
          <>
            <DrawerHeader>
              <Div className="menubar-logo">
                <Logo
                  mini={sidebarOptions.open ? showHeaderMenu : showDropdownSearch}
                  mode={headerTheme.type ?? "light"}
                />
              </Div>

              {showDropdownSearch && !sidebarOptions.open && (
                <Div
                  sx={{
                    display: "inline-flex",
                    marginLeft: "-30px",
                    zIndex: 999,
                  }}
                >
                  <Link href="/home">
                    <img
                      // src={`${ASSET_IMAGES}/Foyerlogo.png`}
                      src={`${ASSET_IMAGES}/HelixMiniLogo.png`}
                      width={37}
                      height={35}
                      alt="Felix logo"
                    />
                  </Link>
                </Div>
              )}

              <IconButton
                className="toggle-sidebar"
                edge="start"
                color="inherit"
                mode={headerTheme.type ?? "light"}
                aria-label="open drawer"
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  overflow: "hidden",
                  fontSize: "0.5rem",
                  borderRadius: "1px",
                  padding: "6px 26px 18px 10px",
                  height: "70px",
                  color: "black",
                  backgroundColor: "white",
                  "&:hover,&:active": {
                    backgroundColor: "white",
                    color: "#017890",
                  },
                }}
                onClick={() => setSidebarOptions({ open: !sidebarOptions.open })}
              >
                <>
                  {sidebarOptions?.open ? (
                    <div className="open-close-icon-theme2">
                      <MenuOpenIcon />
                    </div>
                  ) : (
                    <div className="open-close-icon-theme2">
                      <MenuIcon />
                    </div>
                  )}
                </>
              </IconButton>
            </DrawerHeader>
          </>
        )}

      {sidebarOptions?.style === SIDEBAR_STYLES.CLIPPED_UNDER_HEADER && <></>}

      {/* Edited by vijay 11-30-2023 */}
      <Div
        className="container"
        sx={{
          display: "flex !important",
          justifyContent: "flex-end !important",
          marginRight: { xs: "-35px !important", md: "-50px !important" },
        }}
      >
        <Div sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {!isMobile && (
            <React.Fragment>
              <Div
                onClick={() =>
                  window.open("https://demo.crmfarm.app/", "_blank")
                }
                sx={{
                  cursor: "pointer",
                  backgroundColor: "white",
                  padding: 0.5,
                }}
              >
                <Tooltip title="CRM" placement="top-start">
                  <img
                    // src={CRMlogo}
                    // alt="CRM"
                    // width={90}
                    // height={25}
                    src={CRMlogo}
                    alt="CRM"
                    width={100}
                    height={30}
                  />
                </Tooltip>
              </Div>
              {/* 
              {Tenantname === "relux" ? (
                <Div></Div>
              ) : (
                <Div onClick={() => window.open(`https://boltmm.in/`, '_blank')} sx={{ cursor: "pointer", backgroundColor: "white", padding: 0.5 }}>
                  <Tooltip title="Bolt" placement="top-start">
                    <img
                      src={Boltlogo}
                      alt="Bolt"
                      width={70}
                      height={25}
                    />
                  </Tooltip>
                </Div>
              )} */}

              {userType != "Corporate" && (
                <Div
                  onClick={() => navigate(`/tally/?page=${previousPage}`)}
                  sx={{
                    cursor: "pointer",
                    backgroundColor: "white",
                    padding: 0.5,
                  }}
                >
                  {/* <Div onClick={() => setShowTallyDialogbox(!showTallyDialogbox)} sx={{ cursor: "pointer", backgroundColor: "white", padding: 0.5 }}> */}
                  <Tooltip title="Tally" placement="top-start">
                    <img src={Tallylogo} alt="Tally" width={50} height={40} />
                  </Tooltip>
                </Div>
              )}
            </React.Fragment>
          )}

          <Div
            sx={{ cursor: "pointer", backgroundColor: "white", padding: 0.5 }}
          >
            <Tooltip title="Approvals" placement="top-start">
              {/* <IconButton
                onClick={() => navigate("/samples/content-layout")}
                sx={{
                  color: "#475467",
                  "&:hover": {
                    color: "#7c8ea0",
                    backgroundColor: "rgba(25,118,210,0.08)",
                  },
                }}
              >
                <FactCheckRoundedIcon sx={{ fontSize: 24 }} />
              </IconButton> */}
              <Box
                onClick={() => navigate("/samples/content-layout")}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                  cursor: "pointer",
                  height: "100%",
                }}
              >
                <Badge badgeContent={approvalsCount} color="error" sx={{ "& .MuiBadge-badge": { fontSize: 10, height: 16, minWidth: 16 } }}>
                  <AssignmentTurnedInIcon
                    sx={{ color: "#2E7D32", fontSize: 20 }}
                  />
                </Badge>

                <Typography
                  variant="subtitle2"
                  sx={{ display: { xs: "none", md: "block" }, fontWeight: 600 }}
                >
                  Approvals
                </Typography>
              </Box>
            </Tooltip>
          </Div>

          <Div className="">
            <MessagesDropdown />
          </Div>

          <Div>
            <NotificationsDropdown />
          </Div>

          <Div className="ms-1">
            <AuthUserDropdown />
          </Div>

          <Div
            onClick={toggleCustomizerVisibility}
            sx={{
              cursor: "pointer",
              color: "#000000",
              backgroundColor: "white",
              padding: 0,
            }}
          >
            <IconButton>
              <MoreVertRounded />
            </IconButton>
          </Div>
        </Div>
      </Div>

      {/* <TallyXMLList
        showTallyDialogbox={showTallyDialogbox}
        setShowTallyDialogbox={setShowTallyDialogbox}
      /> */}
    </Div>
  );
};

export default Header;
